function validateCallback(callback, message) {
  if (typeof callback !== "function") throw new TypeError(message);
}
export {
  validateCallback
};
//# sourceMappingURL=validateCallback.js.map
